import Button from "Components/Common/Button/Button";
import Skeleton from "Components/Common/Skeleton/Skeleton";

interface SubmitBarProps {
  lineCount: number;
  totalText: string;
  varianceText: string;
  varianceClass: string;
  isPublished?: boolean;
  isDrafting?: boolean;
  isSubmitting?: boolean;
  isExportingPdf?: boolean;
  loading?: boolean;
  onSaveDraft: () => void;
  onExportPdf: () => void;
  onSubmit: () => void;
}

export default function SubmitBar({
  lineCount,
  totalText,
  varianceText,
  varianceClass,
  isPublished,
  isDrafting = false,
  isSubmitting = false,
  isExportingPdf = false,
  loading = false,
  onSaveDraft,
  onExportPdf,
  onSubmit,
}: SubmitBarProps) {
  return (
    <div className="sovSubmitBar">
      {!loading ? (
        <p className="sovSubmitInfo">
          {lineCount} line items · SOV total:{" "}
          <span className="hl">{totalText}</span> · Variance:{" "}
          <span className={varianceClass}>{varianceText} </span>
        </p>
      ) : (
        <p className="sovSubmitInfo">
          <Skeleton width={200} height={18} />
        </p>
      )}
      <div className="sovSubmitActions">
        {!isPublished && !loading && (
          <Button
            type="button"
            className="btn secondary"
            onClick={onSaveDraft}
            disabled={isDrafting || isSubmitting}
          >
            {isDrafting ? (
              <>
                <span className="btn-spinner" />
                Saving
              </>
            ) : (
              "Save Draft"
            )}
          </Button>
        )}
        <Button
          type="button"
          className="btn secondary"
          onClick={onExportPdf}
          disabled={isExportingPdf}
        >
          {isExportingPdf ? (
            <>
              <span className="btn-spinner" />
              Generating PDF
            </>
          ) : (
            "⬇ Export PDF"
          )}
        </Button>
        {!isPublished && !loading && (
          <Button
            type="button"
            className="btn green"
            disabled={isSubmitting || isDrafting}
            onClick={onSubmit}
          >
            {isSubmitting ? (
              <>
                <span className="btn-spinner" /> Submitting
              </>
            ) : (
              "✓ Submit to CSC & Bank"
            )}
          </Button>
        )}
      </div>
    </div>
  );
}
